/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var pretty_checkbox_react_1 = require("pretty-checkbox-react");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");

var _Radio = function _Radio(_ref) {
  var id = _ref.id,
      name = _ref.name,
      disabled = _ref.disabled,
      className = _ref.className,
      isSelected = _ref.isSelected,
      label = _ref.label,
      onChange = _ref.onChange;

  var handleChange = function handleChange(e) {
    if (onChange) {
      onChange(e);
    }
  };

  return react_1.default.createElement(pretty_checkbox_react_1.Radio, {
    id: id,
    className: classnames_1.default(className),
    checked: isSelected,
    disabled: disabled,
    name: name,
    onChange: function onChange(e) {
      return handleChange(e);
    },
    icon: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
      className: "icon",
      icon: free_solid_svg_icons_1.faCheck,
      style: {
        padding: '2px'
      }
    })
  }, label);
};

exports.default = _Radio;